import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { publicRoutes } from "../../routes";
import Loader from "../Loader";

const AppRouter = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {
          publicRoutes.map(({ path, component, exact }) => < Route
            path={path}
            key={path}
            element={component}
            exact={exact}
          />)
        }
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>

  );
}

export default AppRouter;